import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/facebook/callback — the shared sign-in callback (ChannelCallback) for Facebook. */
const FacebookCallback: React.FC = () => <ChannelCallback platform="facebook" />;

export default FacebookCallback;
